module.exports = __webpack_public_path__ + "static/media/lorenzo-thione.6e2c3342.jpeg";